<template>
  <div class="profile-wrap">
    <div class="card">
      <div class="card-body">
        <fieldset :disabled="loading">
          <div class="col-md-12">
            <h4 class="card-title">About me
              <a v-if="!editing" @click.prevent="editMode" class="btn btn-sm btn-outline-primary">
                <mdb-icon size="lg" icon="edit"/>
              </a>
              <a v-if="editing" @click.prevent="save" class="btn btn-sm btn-outline-success">
                <mdb-icon size="lg" icon="save"/>
              </a>
              <a v-if="editing" @click.prevent="cancel" class="btn btn-sm btn-outline-danger">
                <mdb-icon size="lg" icon="ban"/>
              </a>
            </h4>
            <div class="clearfix">
              <mdb-input class="username" :disabled="!editing" ref="usernameInput" label="My Name" v-model="me.name"
                         :invalid-feedback="errors.name" :validation="!!(errors.name)"></mdb-input>
              <mdb-input class="username" v-if="enablePWD" ref="usernameInput" label="My Password" type="password"
                         v-model="me.pwd"
                         :invalid-feedback="errors.pwd" :validation="!!(errors.pwd)"></mdb-input>
              <mdb-input class="username" v-if="enablePWD" ref="usernameInput" label="Confirm your password"
                         type="password" v-model="me.cpwd"
                         :invalid-feedback="errors.cpwd" :validation="!!(errors.cpwd)"></mdb-input>
              <mdb-input disabled v-model="me.uid">
                <span class="input-group-text" slot="prepend">UID</span>
              </mdb-input>
              <mdb-input disabled v-model="me.channel">
                <span class="input-group-text" slot="prepend">Channel</span>
              </mdb-input>

              <hr>

              <div class="form-group d-flex flex-row justify-content-between">
                <label class="flex-fill">Auto Reply</label>
                <div class="refresh-settings"
                     @click.stop="reloadAutoReplySettings"
                     :class="{loading:autoReplySettingsLoading}"><i class="fas fa-sync fa-lg"></i></div>
                <div class="custom-control custom-switch" @click.stop="toggleAutoReply">
                  <input type="checkbox" class="custom-control-input"
                         :checked="autoReplySettings.enabled">
                  <label class="custom-control-label"></label>
                </div>
              </div>
              <ul class="list-group">
                <li class="list-group-item">
                  <mdb-textarea rows="3" label="自動回覆消息內容"
                                v-model="autoReplySettings.message"
                                placeholder="Message here..."></mdb-textarea>
                </li>
                <li class="list-group-item">
                  <label>第一次收到消息後，多久不再自動發送</label>
                  <div class="form-check">
                    <input class="form-check-input"
                           v-model="autoReplySettings.lock_time"
                           type="radio" name="lock_time" id="1hour" value="3600" />
                    <label class="form-check-label" for="1hour"> 一小时 </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input"
                           v-model="autoReplySettings.lock_time"
                           type="radio" name="lock_time" id="2hour" value="7200" />
                    <label class="form-check-label" for="2hour"> 二小时 </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input"
                           v-model="autoReplySettings.lock_time"
                           type="radio" name="lock_time" id="3hour" value="10800" />
                    <label class="form-check-label" for="3hour"> 三小时 </label>
                  </div>
                </li>
              </ul>

              <hr>

              <div v-if="!inAppWebView" class="form-group d-flex flex-row justify-content-between">
                <label>Enable notifications</label>
                <div @click.stop="toggleNotification" v-if="!notifyLoading" class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" :checked="enableNotify">
                  <label class="custom-control-label"></label>
                </div>
                <div v-if="notifyLoading" class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <ul v-if="!inAppWebView && !notifyLoading" class="list-group">
                <li class="list-group-item"
                    :class="{'green-text': notify.isPushNotificationsSupported, 'red-text':!notify.isPushNotificationsSupported}">
                  <mdb-icon :icon="notify.isPushNotificationsSupported ? 'check' : 'times'"/>
                  Browser supports notifications.
                </li>
                <li class="list-group-item"
                    :class="{'green-text': notify.ifNotificationsPermissionGranted, 'red-text':!notify.ifNotificationsPermissionGranted}">
                  <mdb-icon :icon="notify.ifNotificationsPermissionGranted ? 'check' : 'times'"/>
                  Browser allows notifications.
                </li>
                <li class="list-group-item"
                    :class="{'green-text': notify.isOneSignalRuntimeReady, 'red-text':!notify.isOneSignalRuntimeReady}">
                  <mdb-icon :icon="notify.isOneSignalRuntimeReady ? 'check' : 'times'"/>
                  Onesignal runtime is ready.
                </li>
                <li v-if="inMobile" class="list-group-item"
                    :class="{'green-text': isPWA, 'red-text':!isPWA}">
                  <mdb-icon :icon="isPWA ? 'check' : 'times'"/>
                  <span v-if="isPWA">Install as PWA (Mobile only)</span>
                  <span><a class="pwd-link" v-if="!isPWA" @click="handleInstallPWA">Install as PWA</a> (Mobile only)</span>
                </li>
                <li class="list-group-item"
                    :class="{'green-text': notify.isPushNotificationsEnabled, 'red-text':!notify.isPushNotificationsEnabled}">
                  <mdb-icon :icon="notify.isPushNotificationsEnabled ? 'check' : 'times'"/>
                  Onesignal notification been enabled
                </li>
                <li class="list-group-item"
                    :class="{'green-text': notify.isSubscribedNotification, 'red-text':!notify.isSubscribedNotification}">
                  <mdb-icon :icon="notify.isSubscribedNotification ? 'check' : 'times'"/>
                  Push notification feature enabled
                </li>
              </ul>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>
<script>
import {WebClipDetect} from "../Services/pwaService";
import mdbInput from "mdbvue/src/components/Forms/Input";
import mdbTextarea from "mdbvue/src/components/Forms/MdTextarea";
import {mdbIcon} from "mdbvue/src/components/Content/Fa";
import userHttp, {ValidateError} from "../Services/UserService";
import {isBizChatApp} from "@/utils/detect";
import onesignalService from "@/Services/onesignalService";
import AutoReplyService from "../Services/AutoReplyService";

const userService = new userHttp();
const ENABLE_RESET_PWD = window.RESET_PWD_FEATURE || false;
const {EventBus} = require("../Bus.js");

export default {
  components: {
    mdbTextarea,
    mdbInput,
    mdbIcon
  },
  data() {
    return {
      autoReplySettingsLoading: false,
      autoReplySettings: {
        enabled: false,
        message: "",
        lock_time: 3600,
      },
      me: {},
      ori: {
        name: '',
        pwd: null,
      },
      notifyLoading: false,
      enableNotify: false,
      editing: false,
      loading: false,
      errors: {},
      flag: false,
      notify: {
        ifNotificationsPermissionGranted: false,
        isOneSignalRuntimeReady: false,
        isPushNotificationsSupported: false,
        isPushNotificationsEnabled: false,
        isSubscribedNotification: false,
      }
    };
  },

  computed: {
    enablePWD() {
      return ENABLE_RESET_PWD && this.editing;
    },

    inMobile() {
      return WebClipDetect.isMobileDevice();
    },

    isPWA() {
      return WebClipDetect.isPWA();
    },

    inAppWebView() {
      return isBizChatApp();
    },
  },

  created() {
    this.fetchMe();
    this.renderNotifyOption();
    this.renderAutoReply();
  },

  methods: {
    renderNotifyOption() {
      this.notifyLoading = true;
      return onesignalService.addScript()
          .then(() => {
            return Promise.all([onesignalService.isPushNotificationsEnabled(), onesignalService.isSubscribedNotification()]);
          }, (error) => {
            console.error(error);
            this.notify.isOneSignalRuntimeReady = false;
          })
          .then(([isPushNotificationsEnabled, isSubscribedNotification]) => {
            this.notify = {
              isPushNotificationsEnabled,
              isSubscribedNotification,
              ifNotificationsPermissionGranted: onesignalService.ifNotificationsPermissionGranted,
              isOneSignalRuntimeReady: onesignalService.isOneSignalRuntimeReady,
              isPushNotificationsSupported: onesignalService.isPushNotificationsSupported,
            }
            this.enableNotify = Object.values(this.notify).reduce((last, row) => {
              return last && row;
            }, true);
          }).catch((err) => {
            console.error(err);
            this.enableNotify = false;
          })
          .finally(() => {
            this.notifyLoading = false;
          })
    },

    renderAutoReply() {
      this.autoReplySettingsLoading = true;
      return AutoReplyService.pull().then(data => {
        this.autoReplySettings = {
          ...data,
        };
      }).finally(() => {
        this.autoReplySettingsLoading = false;
      });
    },

    fetchMe() {
      userService.me().then(data => {
        this.ori = {
          ...data
        };
        this.me = {
          ...this.ori,
        }
      });
    },

    editMode() {
      this.editing = true;
      this.me = {
        ...this.ori,
      };
      this.errors = {};
    },

    cancel() {
      this.me = {
        ...this.ori,
      };
      this.editing = false;
    },

    save() {
      if (this.me.pwd && this.me.pwd != this.me.cpwd) {
        this.errors = {
          cpwd: "Passwords don't match",
        };
        return;
      }

      const data = {
        name: this.me.name,
        pwd: this.me.pwd && this.me.pwd.length > 0 ? this.me.pwd : null,
      };

      this.loading = true;

      userService.editMe(data.name, data.pwd)
          .then((data) => {
            this.ori.name = data.name;
            this.editing = false;
            /**
             * 重刷 profile cache
             */
            userService.me(true);
            EventBus.dispatchProfileUpdated();
          })
          .catch((error) => {
            if (error instanceof ValidateError) {
              const msgs = error.getValidate();
              console.log(error);
              console.log(msgs);
              this.errors = {
                ...msgs,
              }
            }
            return Promise.reject(error);
          })
          .finally(() => {
            this.loading = false;
          })
    },

    toggleNotification() {
      if (this.enableNotify) {
        this.notifyLoading = true;
        return userService.unsubscribeNotifications()
            .then(() => {
              return this.renderNotifyOption();
            })
            .finally(() => {
              this.notifyLoading = false;
            })
      }

      if ('Notification' in window) {
        this.notifyLoading = true;
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            return onesignalService.subscribe(0, true);
          }
        }).then(() => {
          return this.renderNotifyOption();
        })
            .finally(() => {
              this.notifyLoading = false;
            })
      }
    },

    handleInstallPWA() {
      this.$nextTick(() => {
        const btn = document.querySelector(".pwd-icon");
        if (btn) {
          btn.click();
        }
      })
    },

    reloadAutoReplySettings() {
      if (this.autoReplySettingsLoading) {
        return;
      }

      this.renderAutoReply();
    },

    toggleAutoReply() {
      this.autoReplySettings.enabled = !this.autoReplySettings.enabled;
      AutoReplyService.store({
        ...this.autoReplySettings,
      })
          .then((data) => {
            this.autoReplySettings = {
              ...data,
            }
          });
    },
  }
};
</script>
<style lang="scss">
.profile-wrap {
  padding: 1em;

  // rotate animation
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .refresh-settings {
    margin-right: 1em;
    cursor: pointer;
    color: var(--green);

    &:hover {
      color: var(--blue);
    }

    &.loading {
      .fas {
        animation: spin 1s linear infinite;
        transform: rotate(360deg);
      }
    }
  }

  .form-check-input[type=radio] {
    border-radius: 50%;
    width: 1.25rem;
    height: 1.25rem;
    margin-top: .125em;
    margin-right: 4px;
  }

  .form-check {
    margin-bottom: 0.5em;

    .form-check-label {
      margin-left: 0.5em;
    }
  }

  input:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  .username {
    & > .form-control {
      padding-left: 0;
    }
  }

  .bell-wrap {
    text-align: right;
  }

  .light {
    .fa-bell {
      color: #2bbbad;
    }
  }

  .list-group-item {
    .fas {
      font-size: 1rem;
      margin-right: 0.5em;
      width: 1rem;
    }
  }

  .pwd-link {
    text-decoration: underline !important;
    color: var(--blue) !important;
  }
}
</style>
